export default {
  'createBill.purchaseorderno': 'Bestellnummer',
  'createBill.IranBranchOffice,No.18,AlvandBuilding,AlvandSt.ArgentinaSq.,Tehran,Iran.Phone:+98 21 88663088': `
  Zweigstelle Iran, Nr. 18, Alvand-Gebäude, Alvand St.
  Argentina Sq., Teheran, Iran.
  Phone: +98 21 88663088`,
  'createBill.date': 'Datum',
  'createBill.supplieraddress': 'Lieferantenadresse',
  'createBill.3061valiasrsttehraniran': '#3061, Valiasr Str., Teheran, Iran',
  'createBill.requestername': 'Name des Anfragenden',
  'createBill.paymentterms': 'Zahlungsbedingungen',
  'createBill.frominvoicereceipt': 'ab rechnungseingang',
  'createBill.projectname': '	Projektname',
  'createBill.test': 'Test',
  'createBill.pos': 'POS',
  'createBill.description': 'Beschreibung',
  'createBill.quantity': 'Menge',
  'createBill.uom': 'Maßenheit',
  'createBill.netprice': 'Nettopreis',
  'createBill.per': 'Pro',
  'createBill.totalprice': 'Gesamtpreis',
  'createBill.curr': 'Curr',
  'createBill.deliverydate': 'Lieferdatum',
  'createBill.NECfullHD1024': 'NEC - Full HD 1024',
  'createBill.sonyultraHD': 'SONY - Ultra HD',
  'createBill.xiaominormalheadset': 'Xiaomi - Normal Headset',
  'createBill.beatshighqualitywireless': 'Beats - Hohe Qualität - Kabelfrei',
  'createBill.totalgrossamount':
    'Insgesamte Bruttobetrag (einschließlich Steuern, falls vorhanden)',
  'createBill.months': 'Monat',
  'createBill.hours': 'Zeit',
  'createBill.days': 'Tag',
  'createBill.novartispharmaserviceAG': 'Novartis Pharma Service AG',
};
